import type { Ctx } from "../../types";
import { Action, invalidate } from "gg-wf-scripts";
import { toast, getErrorStatus } from "../../toast";

export const claim_job: Action<Ctx, { id?: string }> = async ({ sb }, data) => {
  const job_opening_id = data.id;
  if (!job_opening_id) return { ok: false, error: "Missing id on row record" };

  const { error } = await sb.functions.invoke(
    `api/jobs/${job_opening_id}/claim`,
    { method: "POST" }
  );
  if (error) {
    if (getErrorStatus(error) === 409) {
      toast({ variant: "warning", text: "Job was already claimed. Try another!" });
    } else {
      toast({ variant: "error", text: "Job claim failed. Try again" });
    }
    return { ok: false, error: error.message };
  }
  invalidate("jobs");
  toast({ variant: "success", text: "Job claimed!" });
  return { ok: true };
};
